import React from "react";
import { Typography, Layout } from "antd";
import HeaderBar from "../components/common/CommonHeader";
import FooterBar from "../components/common/CommonFooter";

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const TermOfUse = () => {
  return (
    <Layout style={{ background: "#fff" }}>
      <HeaderBar bgColor="#DDC7BB" />
      <Content
        style={{ padding: "60px 80px", maxWidth: 1000, margin: "0 auto" }}
      >
        <div
          style={{
            height: "50px",
            width: "230px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "20px auto",
            borderRadius: "20px",
            padding: "20px",
          }}
          data-aos="zoom-in"
        >
          <Title level={2} style={{ margin: 0 }}>
            Terms of Use
          </Title>
        </div>

        <Typography>
          <Paragraph>
            <Text strong>Effective Date:</Text> October 23, 2025
          </Paragraph>

          <Paragraph>
            These Terms of Use (“Terms”) govern your access to and use of the{" "}
            <Text strong>Not in the Market</Text> website (“Platform”), operated by{" "}
            <Text strong>Not in the Market</Text>, a Dubai-registered company. By
            using our Platform, you agree to these Terms.
          </Paragraph>

          <Title level={4}>1. Platform Purpose</Title>
          <Paragraph>
            Not in the Market provides property listings, listing submission tools,
            and market insights. We connect property buyers and sellers but do
            not facilitate transactions directly on the website. All deals are
            negotiated offline by our consultants.
          </Paragraph>

          <Title level={4}>2. User Eligibility</Title>
          <Paragraph>Our Platform is intended for:</Paragraph>
          <ul>
            <li>Property buyers browsing listings</li>
            <li>Property owners submitting listings</li>
          </ul>
          <Paragraph>
            We do not permit agents or brokers to list properties. Accounts
            found violating this rule will be suspended or banned.
          </Paragraph>

          <Title level={4}>3. User Responsibilities</Title>
          <Paragraph>
            By using our Platform, you agree to the following:
          </Paragraph>
          <ul>
            <li>Submit truthful and accurate property information</li>
            <li>Provide valid ownership documents</li>
            <li>Behave respectfully and lawfully</li>
          </ul>
          <Paragraph>
            You are responsible for the accuracy of your listing and any content
            you submit.
          </Paragraph>

          <Title level={4}>4. Platform Rights</Title>
          <Paragraph>
            We reserve the right to:
          </Paragraph>
          <ul>
            <li>Review, approve, or reject listings</li>
            <li>Remove content that violates these Terms</li>
            <li>Suspend or terminate accounts for misuse</li>
            <li>Update or modify site features and content at any time</li>
          </ul>

          <Title level={4}>5. Intellectual Property</Title>
          <Paragraph>
            All content, branding, layout, and design on the Platform are owned
            by <Text strong>Not in the Market</Text>. You may not copy, reproduce,
            or redistribute any part of the site without written permission.
          </Paragraph>

          <Title level={4}>6. Limitation of Liability</Title>
          <Paragraph>
            We are not liable for:
          </Paragraph>
          <ul>
            <li>User-submitted content</li>
            <li>Third-party services or embedded tools</li>
            <li>Investment outcomes or property transactions</li>
          </ul>
          <Paragraph>
            All listings are verified to the best of our ability, but final due
            diligence is the responsibility of the buyer and seller.
          </Paragraph>

          <Title level={4}>7. Governing Law</Title>
          <Paragraph>
            These Terms are governed by the laws of the country in which the
            listed property is located. Any disputes will be resolved under
            applicable local jurisdiction.
          </Paragraph>

          <Title level={4}>8. Contact</Title>
          <Paragraph>
            For questions or legal inquiries, please contact us at:{" "}
            <Text strong>support@notinthemarket.com</Text>
          </Paragraph>
        </Typography>
      </Content>
      <FooterBar />
    </Layout>
  );
};

export default TermOfUse;
